import React, { useMemo, memo } from 'react';
import { getPetLayout } from '../petLayoutConfig';

/** 1x1 透明占位，避免未加载时布局抖动 */
const PLACEHOLDER_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/**
 * 悟空图片组件 - 按阶段与挨饿状态应用配置的 size/top/left
 * 组件化 + useMemo 减少重算，memo 避免无谓重渲染
 */
const WukongImage = memo(function WukongImage({ phase, isHungry, src, className = 'pet-item' }) {
  const style = useMemo(() => {
    const layout = getPetLayout(phase ?? 1, !!isHungry);
    const s = {
      top: layout.top || undefined,
      width: layout.width || undefined,
      left: layout.left || undefined,
      aspectRatio: layout.aspectRatio || undefined,
    };
    return Object.fromEntries(Object.entries(s).filter(([, v]) => v !== undefined && v !== ''));
  }, [phase, isHungry]);

  const imgSrc = src || PLACEHOLDER_GIF;

  return (
    <img
      src={imgSrc}
      className={className}
      style={style}
      alt=""
      loading="lazy"
      decoding="async"
    />
  );
});

export default WukongImage;
